<script>
    import Vue from "vue";

    export default {
        name: "HelperItemMixin",
        data() {
            return {
            }
        },
        computed: { 
        },
        methods: {
            bundle_shop: function() {
                var [item_shop_price, item_shop_stock, item_shop_exception] = this.calculateBundleShopStatus(this.item);
                return {price: item_shop_price, stock: item_shop_stock, exception: item_shop_exception};
            },

            showCondition: function(condition) {
                var show = '';
                switch(condition) {
                    case 'new': show='Nou (În țiplă)'; break;
                    case 'likenew': show='Ca nou'; break;
                    case 'verygood': show='Stare foarte bună'; break;
                    case 'good': show='Stare bună'; break;
                    case 'acceptable': show='Folosit'; break;
                }   
                return show;
            },

            calculateBundleShopStatus: function(item) {
                var _this = this;
                var price = 0;
                var stock = false;
                var exception = false;
                item.games.forEach(function(subitem, i) {
                    price += parseFloat(typeof subitem.shop != 'undefined' && subitem.shop.price ? subitem.shop.price : 0);
                    if(typeof subitem.shop != 'undefined' && subitem.shop.stock) {
                        stock = true; //at least one subitem in stock
                    }
                    if(typeof subitem.shop == 'undefined' || !subitem.shop.stock) {
                        exception = true; //at least one subitem not in stock or never in stores
                    }
                });

                price = Math.round(price*100)/100;

                return [price, stock, exception];
            },

            suggestPrice: function(item) {
                let suggested_price = 0;

                switch(item.type) {
                    case 'bundle':
                        var [item_shop_price, item_shop_stock, item_shop_exception] = this.calculateBundleShopStatus(item);
                        break;
                    default: 
                        var item_shop_price = (typeof item.shop != 'undefined' && item.shop.price ? item.shop.price : 0);
                        var item_shop_stock = (typeof item.shop != 'undefined' && item.shop.stock ? item.shop.stock : false);
                        break;
                }

                if(!item_shop_price) {
                    //no info, no suggestion
                    suggested_price = 0;
                } else if(!item_shop_stock) {
                    //out of stock, full last price
                    suggested_price = item_shop_price; 
                } else { 
                    //discount based on condition
                    switch(item.condition) {
                        case 'new': suggested_price = item_shop_price * 0.8; break;
                        case 'likenew': suggested_price = item_shop_price * 0.75; break;
                        case 'verygood': suggested_price = item_shop_price * 0.7; break;
                        case 'good': suggested_price = item_shop_price * 0.6; break;
                        case 'acceptable': suggested_price = item_shop_price * 0.5; break;
                    }    
                }
                return Math.round(suggested_price);
            },

            checkDiscount: function (item) {
                var _this = this;

                var suggested_price = _this.suggestPrice(item);

                switch(item.type) {
                    case 'bundle':
                        var [item_shop_price, item_shop_stock, item_shop_exception] = this.calculateBundleShopStatus(item);
                        break;
                    default: 
                        var item_shop_price = (typeof item.shop != 'undefined' && item.shop.price ? item.shop.price : 0);
                        var item_shop_stock = (typeof item.shop != 'undefined' && item.shop.stock ? item.shop.stock : false);
                        var item_shop_exception = false;
                        break;
                }

                if(!suggested_price || !item.price || !item_shop_stock) {
                    return 'white';
                } else if(item_shop_exception) {
                    return 'exception';
                } else if(Math.round(item.price*100/item_shop_price, 0) >= 100){
                    return 'unacceptable';
                } else {
                    if(item.price < suggested_price * 0.5) {
                        return 'new';
                    }
                    if(item.price < suggested_price * 0.7) {
                        return 'likenew';
                    }
                    if(item.price < suggested_price * 0.9) {
                        return 'verygood';
                    }
                    if(item.price > suggested_price * 1.1) {
                        return 'acceptable';
                    }
                    return 'good';
                }
            },

            getDiscount: function(item) {
                switch(item.type) {
                    case 'bundle':
                        var [item_shop_price, item_shop_stock, item_shop_exception] = this.calculateBundleShopStatus(item);
                        break;
                    default: 
                        var item_shop_price = (typeof item.shop != 'undefined' && item.shop.price ? item.shop.price : 0);
                        var item_shop_stock = (typeof item.shop != 'undefined' && item.shop.stock ? item.shop.stock : false);
                        var item_shop_exception = false;
                        break;
                }
                if(item.price && item_shop_price && item_shop_stock) {
                    return (Math.round(item.price*100/item_shop_price, 0) >= 100?'+':'') + (Math.round(item.price*100/item_shop_price, 0) - 100)+"%"+(item_shop_exception?'*':'');
                } 
                return false;
            },

            checkException: function(item) {
                if(item.type=='bundle') {
                    var [item_shop_price, item_shop_stock, item_shop_exception] = this.calculateBundleShopStatus(item);
                    return item_shop_exception;
                }
                return false;
            },

            openLinkInNewTab: function(link) {
                window.open(link, "_blank");
            },


        },
        computed: {
            
        },
    };
</script>
